<div class="panel">
  <h2>Détails</h2>

  <div class="form-group required">
    <label for="firstname">Prènom</label>
    <input id="firstname" type="text" placeholder="" [formControl]="firstname" maxlength="50" />
    <span class="info info-error" [hidden]="firstname.valid || firstname.pristine || !firstname.errors.required">Ce champ est requis</span>
    <span class="info"></span>
  </div>

  <div class="form-group required">
    <label for="lastname">Nom</label>
    <input id="lastname" type="text" placeholder="" [formControl]="lastname" maxlength="50" />
    <span class="info info-error" [hidden]="lastname.valid || lastname.pristine || !lastname.errors.required">Ce champ est requis</span>
    <span class="info"></span>
  </div>

  <div class="form-group required">
    <label for="timezone">Fuseau horaire</label>
    <t-select [items]="timezones" [(item)]="user.timezone" placeholder="Sélectionner un fuseau horaire"></t-select>
  </div>

</div>